module.exports = __webpack_public_path__ + "static/media/numero_oficina.921aeba0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/numero_oficina.svg
// module id = 1762
// module chunks = 0